/* eslint-disable */
const content = {
  component: "PageTypeA",
  cssClass: "page-five",
  meta: {
    title: "Tony’s Chocolonely Delivers on Fair-Trade, High-Growth Virtues",
    description:
      "Wine.com.br has been able to scale operations and toast to success thanks to the Oracle’s marketing cloud.",
    og: {
      type: "website",
      title: "Wine start-up succeeds in cloud—see how",
      description: `Brazil isn’t traditionally a big wine market. But that didn’t stop Brazilian-based Wine.com.br’s success. By using cloud technology, they were able to cultivate meaningful relationships with their customers, enabling them to become the third-biggest wine e-commerce company in the world.`,
      image: require("../../assets/images/social/fair-trade-high-growth-1200x630.jpg")
    },
    twitter: {
      card: "summary",
      title: "Read how cloud enabled Wine.com.br to raise a glass to success.",
      description: `By moving to cloud, Wine.com.br has been able to scale larger, react faster and augment their marketing with personalized content—helping them become the world’s third-largest wine e-commerce company.`,
      site: "@Oracle",
      creator: "@Oracle",
      image: require("../../assets/images/social/fair-trade-high-growth-300x300.jpg")
    }
  },
  title:
    "<span>Tony’s Chocolonely </span>Delivers on Fair&#8209;Trade, <span>High&#8209;Growth Virtues</span>",
  heroImage: {
    preload: require("../../assets/images/bgs/fair-trade-high-growth-pre.jpg"),
    loaded: require("../../assets/images/bgs/fair-trade-high-growth.jpg"),
    mobile: require("../../assets/images/bgs/fair-trade-high-growth-mobile.jpg")
  },
  // * the heroImageOptions are currently only required and supported when using the PageTypeA component
  heroImageOptions: {
    default: {
      customPosition: [true, "center"]
    },
    mobile: {
      customPosition: [true, "top !important"],
      customSize: "100% auto !important"
    },
    limtedHeight: {
      customPosition: [false]
    }
  },
  sections: [
    {
      component: "SectionCopy",
      content: {
        copy: `
        If you don’t love chocolate, you most certainly know someone who does. By the end of last year, consumers worldwide will have spent about $100 billion on more than eight million tons of the smooth, creamy, decadent confection.
        `,
        type: "intro"
      }
    },
    {
      component: "SectionSeperator",
      content: {
        image: null
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
        <p>But what most of us don’t realize is that 70 percent of the world’s chocolate comes from cocoa plantations in West Africa where children, and sometimes even victims of modern slavery, are forced to work under illegal and dangerous conditions, according to a report from Tulane University and the U.S. Department of Labor.</p>
        <p>After uncovering that bitter truth while producing a television show more than a decade ago, Dutch investigative journalist Teun “Tony” van de Keuken and two fellow journalists went on to found Tony’s Chocolonely, based on the principle of producing only “slave-free chocolate”—and influencing other chocolate makers to do the same.</p>
        <p>At six partner cooperatives in Ghana and Côte d’Ivoire, Tony’s Chocolonely works with 5,500 independent farmers to improve their yields using sustainable farming practices. It also provides farmers with agricultural education while paying them a living wage so they can hire adult workers and send their kids to school.</p>
        `,
        type: "default"
      }
    },
    {
      component: "SectionQuote",
      content: {
        quote: `We lead by example and want to inspire others to act. Only together can we make chocolate 100 percent slave-free.`,
        author: `Pascal van Ham`,
        position: `Head of Marketing, Chocolonely`,
        type: "quote",
        backgroundImage: require("../../assets/images/bgs/FairTradeHighGrowth_Chocolonely_bg.jpg")
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
        <p>Those business practices, as well as its sumptuous products, have served Tony’s Chocolonely well. The Amsterdam-based company has maintained a 50 percent annual growth rate since its launch in 2005, despite paying a $175 premium (above published “fair trade” prices) for every metric ton of cocoa beans it purchases. Since 2012, Tony’s Chocolonely has grown its revenue nearly ninefold, to €44.9 million (U.S. $55.3 million) in 2017.</p>
        <p>But such rapid growth hasn’t come without its challenges. As Tony’s Chocolonely increased its revenue, the company quickly outgrew the myriad spreadsheets its sales and finance people used to keep track of business. Mistakes and rework were common. “Maintaining spreadsheets meant our salespeople were spending most of their time fixing errors, not selling chocolate,” says sales “Choconator” Frits Snel.</p>
        `,
        type: "default"
      }
    },
    {
      component: "SectionImage",
      content: {
        image: require("../../assets/images/content/FairTradeHighGrowth_InlineImage.jpg"),
        alt: "",
        type: "image"
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          Because Tony’s Chocolonely buys beans only from partner farmer cooperatives, the company has few supply alternatives if its forecasts miss the mark, making accuracy all the more important. “Predictive planning is critical for us,” says Frans Pannekoek, the company’s “Bean to Bar Tender”, responsible for its supply chain. “It’s not possible to just source from another cooperative if one of our partner cooperatives is unable to supply enough beans.”  
        `,
        type: "default"
      }
    },
    {
      component: "SectionQuote",
      content: {
        quote: `Oracle Cloud helps us create a realistic forecast that I can hand off to operations so my team can start working with the right suppliers and accelerate the flow of goods.`,
        author: `Frans Pannekoek`,
        position: `Supply Chain “Bean to Bar Tender”, Chocolonely`,
        type: "quote"
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          That forecasting not only helps Tony’s Chocolonely deliver on its growth targets, but also on its brand principles.
        `,
        type: "default"
      }
    },
    {
      component: "SectionCallToAction",
      content: {
        title: `Transform your business with Oracle`,
        ctas: [
          {
            image: require("../../assets/images/svgs/report.svg"),
            copy: "Decision makers and technology report",
            url:
              "https://www.oracle.com/uk/applications/erp/cfos-digital-bridge-builders.html?source=:ow:o:cs:mt:RC_EMMK181024P00070C0001:YTTFY19_FI_AW_HI_CM_UK_C33_Q33_RT&intcmp=:ow:o:cs:mt:RC_EMMK181024P00070C0001:YTTFY19_FI_AW_HI_CM_UK_C33_Q33_RT",
            buttonCopy: "Read report"
          },
          {
            image: require("../../assets/images/svgs/servers.svg"),
            copy: "Try out Oracle Cloud Solutions",
            url:
              "https://go.oracle.com/LP=43623?qt=saas_erp_fin_DeliverDecisiveInsightwithOracleFinancialsCloud&src1=:ow:o:cs:mt:RC_EMMK181024P00070C0001:YTTFY19_FI_CT_QT_CM_UK_C38_Q34&intcmp=WWMK161025P00088:ow:o:cs:mt:RC_EMMK181024P00070C0001:YTTFY19_FI_CT_QT_CM_UK_C38_Q34",
            buttonCopy: "Try now"
          }
        ],
        type: "cta"
      }
    }
  ]
};

export default content;
